module.exports = __webpack_public_path__ + "img/icon-back.1a36e191.svg";